import marco from 'shared/img/team/marco.webp';
import lukas from 'shared/img/team/lukas.jpeg';
import fabio from 'shared/img/team/fabio.webp';
import ashline from 'shared/img/team/ashline.webp';
import richard from 'shared/img/team/richard.webp';
import bartek from 'shared/img/team/bartek.webp';
import mateusz from 'shared/img/team/mateusz.webp';
import mikolaj from 'shared/img/team/mikolaj.webp';
import wouter from 'shared/img/team/wouter.webp';
import pedro from 'shared/img/team/pedro.webp';
import balbina from 'shared/img/team/balbina.webp';
import ivan from 'shared/img/team/ivan.webp';
import alex from 'shared/img/team/alex.jpeg';
import daniil from 'shared/img/team/daniil.webp';
import kyril from 'shared/img/team/kyril.webp';
import nikan from 'shared/img/team/nikan.webp';
import angel from 'shared/img/team/angel.webp';
import max from 'shared/img/team/max.webp';
import arlee from 'shared/img/team/arlee.webp';
import denys from 'shared/img/team/denys.webp';
import rafal from 'shared/img/team/rafal.webp';


export const members = [
  {
    title: 'Marco',
    subtitle: 'CEO / Software Engineer',
    image: marco,
    flags: ['it', 'fr', 'lb', 've', 'eu'],
  },
  {
    title: 'Lukas',
    subtitle: 'Board Member',
    image: lukas,
    flags: ['ch', 'eu'],
  },
  {
    title: 'Richard',
    subtitle: 'Product Manager',
    image: richard,
    flags: ['pl', 'eu'],
  },
  {
    title: 'Wouter',
    subtitle: 'Product Manager',
    image: wouter,
    flags: ['be', 'eu'],
  },
  {
    title: 'Arlee',
    subtitle: 'Product Manager',
    image: arlee,
    flags: ['us'],
  },
  {
    title: 'Angel',
    subtitle: 'Product Manager',
    image: angel,
    flags: ['pl', 'eu'],
  },
  {
    title: 'Max',
    subtitle: 'Business Development',
    image: max,
    flags: ['us'],
  },
  {
    title: 'Mikolaj',
    subtitle: 'Technical Advisor',
    image: mikolaj,
    flags: ['pl', 'eu'],
  },
  {
    title: 'Fabio',
    subtitle: 'Software Engineer',
    image: fabio,
    flags: ['pt', 'eu'],
  },
  {
    title: 'Ashline',
    subtitle: 'Software Engineer',
    image: ashline,
    flags: ['zw'],
  },
  {
    title: 'Pedro',
    subtitle: 'Software Engineer',
    image: pedro,
    flags: ['pt', 'eu'],
  },
  {
    title: 'Bartek',
    subtitle: 'Software Engineer',
    image: bartek,
    flags: ['pl', 'eu'],
  },
  {
    title: 'Mateusz',
    subtitle: 'Software Engineer',
    image: mateusz,
    flags: ['pl', 'eu'],
  },
  {
    title: 'Denis',
    subtitle: 'Software Engineer',
    image: denys,
    flags: ['ua', 'eu'],
  },
  {
    title: 'Rafal',
    subtitle: 'Software Engineer',
    image: rafal,
    flags: ['pl', 'eu'],
  },
  {
    title: 'Kyril',
    subtitle: 'Software Engineer',
    image: kyril,
    flags: ['eu'],
  },
  {
    title: 'Alex',
    subtitle: 'Software Engineer',
    image: alex,
    flags: ['eu'],
  },
  {
    title: 'Ivan',
    subtitle: 'Software Engineer',
    image: ivan,
    flags: ['eu'],
  },
  {
    title: 'Dan',
    subtitle: 'Software Engineer',
    image: daniil,
    flags: ['eu'],
  },
  {
    title: 'Nikan',
    subtitle: 'Software Engineer',
    image: nikan,
    flags: ['eu'],
  },
  {
    title: 'Balbina',
    subtitle: 'Administration',
    image: balbina,
    flags: ['eu', 'pl'],
  },
]
